export const classNames = (...items) => items.filter(a => a).join(' ')
export const removeProductsFromSlug = slug =>
  slug && slug.startsWith('products/') ? slug.replace('products/', '') : slug
